<!--components\Alineacion\Convergencia.vue-->
<template>
  <section class="flex flex-col pb-10 pt-10 items-center">
    <div class="max-w-[76rem] w-full px-4 md:px-8">
      <!-- Título -->
      <h2 class="text-2xl lg:text-3xl font-semibold text-center mb-8">
        {{ Data.titulo }}
      </h2>

      <!-- Contenedor principal dividido en 2 -->
      <div class="flex flex-col md:flex-row gap-8">
        <!-- Lado izquierdo: Párrafos -->
        <div class="flex flex-col gap-4 w-full md:w-[80%] justify-center">
          <p v-for="(parrafo, index) in Data.parrafos" :key="index" class="text-base leading-normal text-justify">
            {{ parrafo }}
          </p>
        </div>

        <!-- Lado derecho: Imágenes con títulos -->
        <div class="flex flex-col gap-6 w-full md:w-[20%]">
          <!-- Convergente -->
          <div class="flex flex-col gap-2 items-center">
            <h3 class="text-xl font-bold text-red-600 flex items-center gap-2">
              {{ Data.textoimagen1 }}
            </h3>
            <img :src="Data.imagen1" alt="Convergente" class="w-[70%] md:w-full h-auto">
          </div>

          <!-- Divergente -->
          <div class="flex flex-col gap-2 items-center">
            <h3 class="text-xl font-bold text-red-600 flex items-center gap-2">
              {{ Data.textoimagen2 }}
            </h3>
            <img :src="Data.imagen2" alt="Divergente" class="w-[70%] md:w-full h-auto">
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref } from 'vue'

const Data = ref({
  titulo: '¿Qué son la convergencia y la divergencia?',
  parrafos: [
    'Es fácil darse cuenta si nuestro auto tiene un problema con la convergencia y divergencia.',
    'Si lo miramos de frente, en caso de la convergencia, podremos ver cómo las ruedas delanteras están desviadas hacia el interior. Además, al pasar la mano por el neumático, notaremos asperezas desde el interior hacia el exterior del neumático.',
    'El otro efecto con el que nos podemos encontrar es la divergencia. En este caso, al ver el vehículo de frente, veremos cómo las ruedas delanteras están también desviadas, pero hacia el exterior. Si pasamos la mano por el neumático, notaremos las asperezas desde el exterior hacia el interior de éste.',
    'Otro índice que se puede medir a la hora de realizar la alineación es el ángulo de caída. Un vehículo tiene caída cuando, al verlo de frente, observamos cómo las ruedas están inclinadas hacia el interior o hacia el exterior. Un valor de ángulo de caída superior al marcado por el fabricante provoca un desgaste irregular del neumático.'
  ],
  textoimagen1: 'Convergente',
  imagen1: '/img/alineacion/convergente.png',
  textoimagen2: 'Divergente',
  imagen2: '/img/alineacion/divergente.png'
})
</script>